export enum InteractionStatus {
  NOT_INDEXED = 'not_indexed',
  INDEXED = 'indexed',
  TRASHED = 'trashed',
};
